import React from 'react';

interface State {
  hasError: boolean;
  eventId?: string;
}

class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 font-sans px-4">
        <div className="bg-white rounded-3xl shadow-xl p-10 max-w-sm w-full text-center space-y-5">
          <div className="text-5xl">⚠️</div>
          <h1 className="text-xl font-bold text-navy">
            エラーが発生しました
            <span className="block text-base font-normal text-slate-500 mt-1">页面发生了错误</span>
          </h1>
          <p className="text-sm text-slate-500 leading-relaxed">
            ページの読み込み中に問題が発生しました。<br />
            ページを再読み込みするか、しばらくしてからもう一度お試しください。
          </p>
          <div className="flex flex-col gap-3 pt-2">
            <button
              onClick={() => window.location.reload()}
              className="w-full py-3 rounded-2xl bg-coral text-white font-bold text-sm hover:opacity-90 transition-all active:scale-[0.98]"
            >
              ページを再読み込み / 刷新页面
            </button>
            <button
              onClick={() => { window.location.href = '/'; }}
              className="w-full py-3 rounded-2xl bg-slate-100 text-slate-600 font-semibold text-sm hover:bg-slate-200 transition-all"
            >
              トップへ戻る / 返回首页
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
